import { FunctionComponent } from 'react';
import Script from 'next/script';

import { NEXT_PUBLIC_TAG_MANAGER } from 'src/env';

export const TagManager: FunctionComponent = () => {
  if (!NEXT_PUBLIC_TAG_MANAGER) {
    return null;
  }
  return (
    <Script
      id="google-tag-manager"
      strategy="afterInteractive"
      async
      dangerouslySetInnerHTML={{
        __html: `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer', '${NEXT_PUBLIC_TAG_MANAGER}');
      `,
      }}
    />
  );
};
